<template>
  <SoButton
    data-testid="issue-header-back-button"
    type="icon"
    prepend-icon="arrow-left"
    title="Back"
    @click="$router.back()"
  />
  <h2 data-testid="issue-header-key" class="font-weight-bold">
    {{ jiraIssue.key }}:
    {{ jiraIssue.fields.summary }}
  </h2>
  <SoLink
    class="w-fit-content"
    data-testid="issue-header:jira-link"
    :text="issueJiraUrl"
    :href="issueJiraUrl"
  />
  <div class="d-flex">
    <h5 class="w-20 font-weight-bold">Reporter</h5>
    <h6 data-testid="issue-header-reporter-name">
      {{ jiraIssue.fields.reporter.displayName }}
    </h6>
  </div>
  <div class="d-flex">
    <h5 class="w-20 font-weight-bold">Priority</h5>
    <h6 data-testid="issue-header-priority">
      {{ jiraIssue.fields.priority.name }}
    </h6>
  </div>
  <div class="d-flex">
    <h5 class="w-20 font-weight-bold">Created</h5>
    <h6 data-testid="issue-header-created">
      {{ dayjs(jiraIssue.fields.created).format("ddd, D MMM YY h:mm A") }}
    </h6>
  </div>
  <div class="d-flex">
    <h5 class="w-20 font-weight-bold">System</h5>
    <h6 data-testid="issue-header-system">
      {{ jiraIssue.fields.customfield_10092?.value }}
    </h6>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoLink from "@/components/SoLink.vue"
  import { IJiraIssue } from "@/models/jiraIssue/jiraIssue.types"
  import SoButton from "@/components/formControls/SoButton.vue"
  import dayjs from "dayjs"

  export default defineComponent({
    components: { SoButton, SoLink },
    props: {
      jiraIssue: {
        type: Object as PropType<IJiraIssue>,
        default: {} as IJiraIssue,
        required: true,
      },
    },
    computed: {
      issueJiraUrl() {
        return "https://soenergy.atlassian.net/browse/" + this.jiraIssue.key
      },
    },
    methods: { dayjs },
  })
</script>

<style scoped>
  .w-20 {
    min-width: 20%;
  }

  .w-fit-content {
    width: fit-content;
  }
</style>
